<div class="modal-header bg-modal-danger">
  <h5 class="modal-title">{{headerTitle}}</h5>
</div>

<div class="modal-body">
  <div class="col">
    {{message}}
  </div>
</div>
<div class="modal-footer">
  <button (click)="onCancel()" class="btn btn-secondary btn-sm">Cancel</button>
  <button (click)="onOk()" class="btn btn-sm btn-success">Confirm</button>
</div>